import { render, staticRenderFns } from "./Reporte_evaluaciones2.vue?vue&type=template&id=2f6a7f46&scoped=true"
import script from "./Reporte_evaluaciones2.vue?vue&type=script&lang=js"
export * from "./Reporte_evaluaciones2.vue?vue&type=script&lang=js"
import style0 from "./Reporte_evaluaciones2.vue?vue&type=style&index=0&id=2f6a7f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a7f46",
  null
  
)

export default component.exports